import { render } from "./CategorySort2.vue?vue&type=template&id=7388ede2&scoped=true"
import script from "./CategorySort2.vue?vue&type=script&lang=js"
export * from "./CategorySort2.vue?vue&type=script&lang=js"

import "./CategorySort2.vue?vue&type=style&index=0&id=7388ede2&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7388ede2"]])

export default __exports__